import axiosInstance from "../helper/axiosIntanceApiZalo";
import axios from '../helper/axiosIntance';
import { normalizeStringInObject } from "../utils/normalize";

//tien
const view = (params) => {
    return axios.post('/notification/api/view', normalizeStringInObject(params));
}
const viewNoti = (params) => {
    return axios.post('/notification/api/viewNoti', normalizeStringInObject(params));
}
//ADD
const create = (params) => {
    return axios.post('/notification/api/create', normalizeStringInObject(params))
}
const edit = (params) => {
    return axios.post('/notification/api/edit', normalizeStringInObject(params))
}
const delelte_force = (params) => {
    return axios.post('/notification/api/delete', normalizeStringInObject(params))
}
const mark_all_as_read = (params) => {
    return axios.post('/notification/api/markAllAsRead', normalizeStringInObject(params))
}
export default {
    view,
    create,
    edit,
    delelte_force,
    viewNoti,
    mark_all_as_read
}
